import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

function ShowroomTable() {
  const [showrooms, setShowrooms] = useState([]);
  const [form, setForm] = useState({ name: "", location: "" });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchShowrooms();
  }, []);

  async function fetchShowrooms() {
    const { data } = await supabase.from("showroom").select("*").order("id");
    setShowrooms(data || []);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name) return alert("Enter a showroom name");
    if (editId) {
      await supabase.from("showroom").update(form).eq("id", editId);
    } else {
      await supabase.from("showroom").insert([form]);
    }
    setForm({ name: "", location: "" });
    setEditId(null);
    fetchShowrooms();
  }

  function handleEdit(row) {
    setForm({ name: row.name, location: row.location });
    setEditId(row.id);
  }

  async function handleDelete(id) {
    if (!window.confirm("Delete this showroom?")) return;
    await supabase.from("showroom").delete().eq("id", id);
    fetchShowrooms();
  }

  const thStyle = {
    padding: "6px 8px",
    borderBottom: "1.5px solid #d2cbc1",
    background: "#f2ede4",
    fontWeight: "bold",
    fontSize: 13,
    textAlign: "left",
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: "6px 8px",
    fontSize: 13,
    textAlign: "left",
    verticalAlign: "top",
    background: "#faf8f4",
    borderBottom: "1px solid var(--line, #d2cbc1)",
  };

  const btnStyle = {
    padding: "4px 12px",
    borderRadius: 6,
    cursor: "pointer",
    border: "none",
    fontWeight: "bold",
  };

  return (
    <div className="ui-legacy-page"
      dir="ltr"
      style={{
        maxWidth: 600,
        margin: "auto",
        background: "#f2ede4",
        borderRadius: 14,
        padding: 28,
        fontFamily: "Jost, 'Trebuchet MS', Arial, sans-serif",
        minHeight: "100vh",
        boxShadow: "0 2px 10px #51453610",
        textAlign: "left",
      }}
    >
      <h2 style={{ color: "var(--accent, #514536)", marginBottom: 20 }}>Showrooms</h2>
      <form className="ui-form ui-toolbar"
        onSubmit={handleSubmit}
        style={{
          marginBottom: 18,
          display: "flex",
          gap: 10,
          direction: "ltr",
        }}
      >
        <label className="ui-field">Showroom name<input
          required
          placeholder="Showroom name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          style={{
            flex: 2,
            padding: 8,
            fontSize: 14,
            borderRadius: 6,
            border: "1px solid #d2cbc1",
          }}
        /></label>
        <label className="ui-field">Location<input
          placeholder="Location"
          value={form.location}
          onChange={(e) => setForm((f) => ({ ...f, location: e.target.value }))}
          style={{
            flex: 2,
            padding: 8,
            fontSize: 14,
            borderRadius: 6,
            border: "1px solid #d2cbc1",
          }}
        /></label>
        <button className="ui-primary"
          type="submit"
          style={{
            backgroundColor: "var(--accent, #514536)",
            color: "#faf8f4",
            padding: "8px 20px",
            borderRadius: 8,
            border: "none",
            cursor: "pointer",
            fontWeight: "bold",
            flexShrink: 0,
          }}
        >
          {editId ? "Refresh" : "Add"}
        </button>
        {editId && (
          <button className="ui-secondary"
            type="button"
            onClick={() => {
              setForm({ name: "", location: "" });
              setEditId(null);
            }}
            style={{
              backgroundColor: "#d2cbc1",
              color: "#514536",
              padding: "8px 20px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
              flexShrink: 0,
            }}
          >
            Cancel
          </button>
        )}
      </form>
      <div className="ui-table-scroll"><table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#faf8f4",
          borderRadius: 12,
          boxShadow: "0 1px 10px #51453610",
          fontSize: 13,
          direction: "ltr",
          textAlign: "left",
        }}
      >
        <thead>
          <tr style={{ background: "#f2ede4", color: "var(--accent, #514536)" }}>
            <th style={thStyle}>#</th>
            <th style={thStyle}>Showroom name</th>
            <th style={thStyle}>Location</th>
            <th style={thStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {showrooms.map((row, i) => (
            <tr key={row.id} style={{ borderBottom: "1px solid var(--line, #d2cbc1)" }}>
              <td style={tdStyle}>{i + 1}</td>
              <td style={tdStyle}>{row.name}</td>
              <td style={tdStyle}>{row.location}</td>
              <td style={{ ...tdStyle, whiteSpace: "nowrap" }}><div className="ui-actions">
                <button className="ui-primary"
                  onClick={() => handleEdit(row)}
                  style={{
                    ...btnStyle,
                    marginLeft: 8,
                    backgroundColor: "var(--accent, #514536)",
                    color: "#faf8f4",
                  }}
                >
                  Edit
                </button>
                <button className="ui-secondary"
                  onClick={() => handleDelete(row.id)}
                  style={{ ...btnStyle, color: "#514536", background: "none" }}
                >
                  Delete
                </button>
              </div></td>
            </tr>
          ))}
          {showrooms.length === 0 && (
            <tr>
              <td
                colSpan={4}
                style={{ color: "#716759", textAlign: "center", padding: 20 }}
              >
                No showrooms yet
              </td>
            </tr>
          )}
        </tbody>
      </table></div>
    </div>
  );
}

export default ShowroomTable;
